import SEOHead from "@/components/General/SEOHead";
import Events from "@/modules/Events/Events";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

const EventsPage = () => {
  return (
    <>
      <SEOHead />
      <Events />
    </>
  );
};

export const getServerSideProps = async ({ locale }: any) => ({
  props: {
    ...(await serverSideTranslations(locale, ["common"])),
  },
});

export default EventsPage;
